import styled from 'styled-components';
import { fonts } from 'themes/default';
import { Container } from 'admin-components/components';

const { fontStyleRegular } = fonts;

export const StyledText = styled.span`
  ${fontStyleRegular}
  font-weight: ${(props) => (props.bold ? 600 : 400)};
`;

export const TableHeaderContainer = styled(Container)`
  margin-top: 20px;
  padding-left: 20px;
  box-sizing: border-box;
`;
